"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.state = void 0;
const state = (onUpdateTrigger) => {
    let value = undefined;
    const updater = (newValue) => {
        value = newValue;
        onUpdateTrigger?.(newValue);
    };
    return (initialValue) => {
        value = initialValue;
        return [value, updater];
    };
};
exports.state = state;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcGFja2FnZXMvY29yZS9zdGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBTyxNQUFNLEtBQUssR0FBRyxDQUNuQixlQUFvQyxFQUNZLEVBQUU7SUFDbEQsSUFBSSxLQUFLLEdBQWtCLFNBQVMsQ0FBQztJQUVyQyxNQUFNLE9BQU8sR0FBRyxDQUFDLFFBQVcsRUFBRSxFQUFFO1FBQzlCLEtBQUssR0FBRyxRQUFRLENBQUM7UUFDakIsZUFBZSxFQUFFLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDOUIsQ0FBQyxDQUFDO0lBRUYsT0FBTyxDQUFDLFlBQWUsRUFBRSxFQUFFO1FBQ3pCLEtBQUssR0FBRyxZQUFZLENBQUM7UUFFckIsT0FBTyxDQUFDLEtBQUssRUFBRSxPQUFPLENBQUMsQ0FBQztJQUMxQixDQUFDLENBQUM7QUFDSixDQUFDLENBQUM7QUFmVyxRQUFBLEtBQUssU0FlaEIifQ==